import {DropdownMenu} from 'quickstart/components'
import {ComponentProps, forwardRef} from 'react'
import {NavLink, NavLinkProps} from '.'

export type NavLinkMenuProps = {
  label?: string
  items?: Omit<NavLinkProps, 'variant'>[]
  menuProps?: ComponentProps<typeof DropdownMenu>
  itemProps?: ComponentProps<typeof DropdownMenu.Item>
}

export const NavLinkMenu = forwardRef<any, NavLinkMenuProps>(
  ({label = '', items = [], menuProps, itemProps}, ref) => {
    return (
      <DropdownMenu label={label} variant="nav" {...menuProps} ref={ref}>
        {items.map((props, i) =>
          'items' in props ? (
            <NavLink key={i} {...itemProps} {...props} />
          ) : (
            <DropdownMenu.Item key={i} as={NavLink} {...itemProps} {...props} />
          ),
        )}
      </DropdownMenu>
    )
  },
)
